import React from 'react';

export const Visa = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="87"
      height="69"
      fill="none"
      viewBox="0 0 87 69"
    >
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M78.138 11h7.609v56.667H9.08v-9.525"
      ></path>
      <path
        fillRule="evenodd"
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.08 1h76.667v56.667H1.08V1z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M15.924 22.667h4.27l1.207 12a1.493 1.493 0 002.833.493L30.4 22.303M36.444 22.563l-2.707 13.54M48.84 22.407s-4.583-1.2-6.147 1.406c-1.563 2.607.887 4.27 2.5 5.26 1.614.99 3.387 2.5 2.917 4.27-.47 1.77-2.447 4.377-7.667 2.554M52.734 36.103l6.267-12.63a1.453 1.453 0 012.75.527l1 11.897M54.727 32.093h7.76"
      ></path>
    </svg>
  );
};
